import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiFetch } from '../../../utilities/appFetch';
import clientRoutes from '../../../components/client/clientRoutes';

const readAll = createAsyncThunk(
  'thunk/client/readAll',
  async (arg, thunkAPI) => {
    const response = await apiFetch(clientRoutes.api.readAll, {
      body: arg?.data,
    });
    if (!response?.success) {
      return thunkAPI.rejectWithValue(response);
    }
    return response.result;
  },
);

export default readAll;
